import { Injectable, inject } from '@angular/core';
import {Observable, ReplaySubject, Subject} from 'rxjs';
import {Zone, ZoneDto} from './zone';
import { HttpClient } from '@angular/common/http';
import {environment} from '../../environments/environment';
import {filter, map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ZoneService {
  private http = inject(HttpClient);

  zones$: Subject<Array<Zone>> = new ReplaySubject(1);

  constructor() {
    this.http
      .get<Array<ZoneDto>>(`${environment.apiUrl}/zones`)
      .pipe(map(dtos => dtos.map(dto => Zone.deserialize(dto))))
      .subscribe(zones => this.zones$.next(zones));
  }

  getZones$(): Observable<Array<Zone>> {
    return this.zones$.asObservable();
  }

  getZonesFor$(zoneIds: Array<string>): Observable<Array<Zone>> {
    return this.getZones$().pipe(map(zones => zones.filter(zone => zoneIds.includes(zone.getId()))));
  }
}
